import { FIND_MY_ACCOUNT_URL, PAY_WITH_ALPHAEON_URL } from 'shared';
import { readPwaSession } from 'utils';
import { isPwaChannel } from '../constants';
const FMA_SESSION_KEY = 'findMyAccount_session';
export function readFmaSession() {
    const raw = sessionStorage.getItem(FMA_SESSION_KEY);
    if (!raw)
        return null;
    try {
        return JSON.parse(raw);
    }
    catch {
        sessionStorage.removeItem(FMA_SESSION_KEY);
        return null;
    }
}
export function writeFmaSession(patch) {
    const existing = readFmaSession() ?? {};
    sessionStorage.setItem(FMA_SESSION_KEY, JSON.stringify({ ...existing, ...patch }));
}
export function clearFmaSession() {
    sessionStorage.removeItem(FMA_SESSION_KEY);
}
export function channelEntryPath() {
    const pwaSession = readPwaSession();
    if (!pwaSession || !isPwaChannel(pwaSession.channel)) {
        return FIND_MY_ACCOUNT_URL;
    }
    return pwaSession.locationId
        ? `${PAY_WITH_ALPHAEON_URL}?location_id=${pwaSession.locationId}`
        : PAY_WITH_ALPHAEON_URL;
}
